/**
 * useUsage — small global cache of /api/usage/me so multiple components
 * (Countdown strip, Notification bell, Dashboard card, Settings card)
 * don't each re-fetch the same payload. Refreshes every 60 s.
 */
import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
const listeners = new Set();
let inFlight = null;

async function fetchUsage() {
  if (inFlight) return inFlight;
  inFlight = api.get("/usage/me")
    .then((r) => {
      cached = r.data;
      listeners.forEach((cb) => cb(cached));
      return cached;
    })
    .catch(() => null)
    .finally(() => { inFlight = null; });
  return inFlight;
}

export function useUsage(pollMs = 60000) {
  const [usage, setUsage] = useState(cached);

  useEffect(() => {
    if (!cached) fetchUsage().then((u) => u && setUsage(u));
    listeners.add(setUsage);
    const id = setInterval(fetchUsage, pollMs);
    return () => {
      listeners.delete(setUsage);
      clearInterval(id);
    };
  }, [pollMs]);

  return usage;
}

export function invalidateUsage() {
  cached = null;
  return fetchUsage();
}
